import React from 'react';
import { v4 } from 'uuid';

export default WrappedComponent => ({ doesMakeServerRequest, ...rest }) => {
	if (doesMakeServerRequest) rest['correlation_id'] = v4();
	return <WrappedComponent {...rest} />;
};
